import React from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import { WhyChoose } from "@/components/WhyChoose";
import { Process } from "@/components/Process";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Clients } from "@/components/Clients";
import { Retainer } from "@/components/Retainer";
import { Testimonials } from "@/components/Testimonials";
import { KnowledgeCenter } from "@/components/KnowledgeCenter";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { waLink } from "@/data/content";

const FloatingWhatsApp = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-wa"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 200 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg"
    aria-label="WhatsApp"
  >
    <MessageCircle className="h-7 w-7" />
  </motion.a>
);

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: true }}>
      <div className="App bg-white">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Pricing />
          <Services />
          <WhyChoose />
          <Process />
          <BrandMarquee />
          <Clients />
          <Retainer />
          <Testimonials />
          <KnowledgeCenter />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
